import {
  useState,
  useRef,
  
  useImperativeHandle,
  forwardRef,
} from "react";

import AddPerMileTaxReport from "./PerMileTaxReport/addPerMileTaxReport";
import IFTAFeature from "./IFTAFeature/IFTAFeature";
import AddIFTAFeature from "./IFTAFeature/Add_IFTA_Feature";
import ListPerMileTaxReport from "./PerMileTaxReport/listPerMileTaxReport";


export interface IFTARef {
  addEditModelAdd_IFTA_Feature: (data?: any) => void;
  addEditModelPerMileTaxReportopen: (data?: any) => void;
}

interface Props {
  selectedTab: number;
  setSelectedTab: React.Dispatch<React.SetStateAction<number>>;
}

const IFtAdetails = forwardRef<IFTARef, Props>(
  ({ selectedTab, setSelectedTab }, ref) => {
    const hide3 = useRef<any>(null);
    const MarketResearchref: any = useRef(null);
    const MileTaxReportREF: any = useRef(null);
    const [allDataIFTA, setAllDataIFTA] = useState([]);
    const [allData, setAllData] = useState([]);
    const clickTab = (tabIndex: React.SetStateAction<number>) => {
      setSelectedTab(tabIndex);
    };
    const [AddPerMileTaxReportopen, setAddPerMileTaxReportopen] =
      useState(false);
    const [AddPerMileTaxReportopendata, setAddPerMileTaxReportopendata] =
      useState("");
    const closeModalAddPerMileTaxReport = () => {
      setAddPerMileTaxReportopen(false);
    };

    const addEditModelPerMileTaxReportopen = (data?: any) => {
      setAddPerMileTaxReportopendata(data);
      setAddPerMileTaxReportopen(true);
    };

    const [Add_IFTA_Feature_open, setAdd_IFTA_Feature_open] = useState(false);
    const [Add_IFTA_Feature_data, setAdd_IFTA_Feature_data] = useState("");

    const closeModalAdd_IFTA_Feature = () => {
      setAdd_IFTA_Feature_open(false);
    };

    const addEditModelAdd_IFTA_Feature = (data?: any) => {
      setAdd_IFTA_Feature_data(data);
      setAdd_IFTA_Feature_open(true);
    };

    const getdataUpdated = () => {
      MarketResearchref?.current?.getDataALL();
    };

    const getdataUpdated2 = () => {
      MileTaxReportREF?.current?.getDataALLPERMILE();
    };

    useImperativeHandle(ref, () => ({
      addEditModelAdd_IFTA_Feature: addEditModelAdd_IFTA_Feature,
      addEditModelPerMileTaxReportopen: addEditModelPerMileTaxReportopen,
    }));

    return (
      <>
        <div className="rightside">
          <div className="loadlisting">
            <div className="">
              <div className="flex-between px-3 ">
                <div className="flex-gap">
                  <button
                    className={` px-2 py-[6px] text-sm  lg:px-4 lg:py-[6px]  rounded-md font-medium border-[1px] 
                               ${
                                 selectedTab === 1
                                   ? "border-customOrange text-customOrange"
                                   : " border-gray-200 "
                               }`}
                    onClick={() => clickTab(1)}
                  >
                    IFTA States
                  </button>

                  <button
                    className={` px-2 py-[6px] text-sm  lg:px-4 lg:py-[6px]  rounded-md font-medium border-[1px] 
                               ${
                                 selectedTab === 2
                                   ? "border-customOrange text-customOrange"
                                   : " border-gray-200  "
                               }`}
                    onClick={() => clickTab(2)}
                  >
                    Special States
                  </button>
                </div>
              </div>
              {selectedTab === 1 && (
                <IFTAFeature
                  ref={MarketResearchref}
                  allData={allDataIFTA}
                  setAllData={setAllDataIFTA}
                />
              )}
              {selectedTab === 2 && (
                <ListPerMileTaxReport
                  ref={MileTaxReportREF}
                  allData={allData}
                  setAllData={setAllData}
                />
              )}
            </div>
          </div>
        </div>

        <AddPerMileTaxReport
          isOpen={AddPerMileTaxReportopen}
          openModal={AddPerMileTaxReportopendata}
          closeModal={closeModalAddPerMileTaxReport}
          ref={hide3}
          getDataALLs={getdataUpdated2}
        />

        <AddIFTAFeature
          isOpen={Add_IFTA_Feature_open}
          openModal={Add_IFTA_Feature_data}
          closeModal={closeModalAdd_IFTA_Feature}
          ref={hide3}
          getDataALLs={getdataUpdated}
        />
      </>
    );
  }
);

export default IFtAdetails;
